import { render, staticRenderFns } from "./area-common.vue?vue&type=template&id=31b57afb&scoped=true"
import script from "./area-common.vue?vue&type=script&lang=js"
export * from "./area-common.vue?vue&type=script&lang=js"
import style0 from "./area-common.vue?vue&type=style&index=0&id=31b57afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b57afb",
  null
  
)

export default component.exports